import {autoinject} from 'aurelia-dependency-injection'
import {EntityManager, Repository} from "aurelia-orm";
import {ThemeColor} from"../entities/theme-color";

@autoinject()
export class ThemeColorService {

    repository: Repository;

    constructor(private entityManager: EntityManager) {
        this.repository = entityManager.getRepository("ThemeColor");
    }
    

    list(themeId:number, themeColorTypeId: number) {
        //return this.http.get("themecolors/list/" + themeId + "/" + themeColorTypeId);
        return this.repository.find('list?themeId=' + themeId + "&themeColorTypeId=" + themeColorTypeId);
    }

    getNew(): ThemeColor {
        return this.repository.getNewEntity();
    }

}